import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PatientProvider } from '../../providers/patient/patient';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { Subject } from 'rxjs';

@Component({
  selector: 'chart-dialog',
  templateUrl: 'chart-dialog.html'
})
export class ChartDialogComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  form: FormGroup;
  program_id: string;
  patient: any;
  user: any;
  chart_types: any[] = [];

  constructor(
    private db: DatabaseProvider,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ChartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private auth: AuthProvider
  ) {
    this.patient = data.patient;
    this.program_id = data.program_id;
    this.db
    .getAdminSettings(this.program_id)
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe((settings) => {
      this.chart_types = settings[2]['types'];
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      type: [null, Validators.required],
      date: [null, Validators.required],
      notes: [null, Validators.required]
    })
    this.form.controls['date'].setValue(new Date());
  }

  ngOnDestroy() {
    console.log('Leaving chart dialog and destroying subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  submit() {
    let chart = this.form.value;
    this.dialogRef.close(chart);
  }
}



// WEBPACK FOOTER //
// ./src/components/chart-dialog/chart-dialog.ts